/**
 * Default Voice Management
 * Handles setting default voice for ensemble members
 */

export function initDefaultVoiceSelect(selectId) {
    // Initialize select2 for default voice with simplified configuration (like song voices)
    if ($(selectId).length) {
        const $select = $(selectId);
        
        // Configuration options
        const select2Options = {
            width: '100%',
            minimumResultsForSearch: Infinity, // Disable search dropdown like in song voices
            placeholder: "Wybierz głos...",
            allowClear: false
        };

        // If inside a Bootstrap modal, keep dropdown within modal
        const $modalAncestor = $select.closest('.modal');
        if ($modalAncestor.length) {
            select2Options.dropdownParent = $modalAncestor;
        }

        $select.select2(select2Options);
        
        return $select;
    }
    return null;
}

export function handleDefaultVoiceChange(selectId, saveButtonId) {
    // Show/hide save button when default voice is selected
    $(selectId).on('change', function() {
        const $saveButton = $(saveButtonId);
        if ($(this).val()) {
            $saveButton.removeClass('d-none');
        } else {
            $saveButton.addClass('d-none');
        }
    });
}

export function handleDefaultVoiceSave(saveButtonId, selectId, ensembleSlug, editedUserId = null, options = {}) {
    // Handle saving default voice
    $(saveButtonId).on('click', function() {
        const $button = $(this);
        const $select = $(selectId);
        const voiceId = $select.val();

        if (!voiceId) {
            alert('Proszę wybrać głos');
            return;
        }

        // Disable button and show loading state
        const originalText = $button.html();
        $button.prop('disabled', true).html('<i class="spinner-border spinner-border-sm me-1"></i>Zapisuję...');

        // Prepare form data
        const formData = new FormData();
        formData.append('voice_id', voiceId);
        formData.append('ensemble_slug', ensembleSlug);
        if (editedUserId) {
            formData.append('edited_user_id', editedUserId);
        }
        formData.append('csrfmiddlewaretoken', $.cookie('csrftoken'));

        // Send AJAX request
        fetch('/api/set-default-voice', {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                
                // Execute custom success callback if provided
                if (options.onSuccess && typeof options.onSuccess === 'function') {
                    options.onSuccess(data);
                } else {
                    // Default success behavior (for main page)
                    // Hide the selection section with animation
                    const $selectionSection = $('#default-voice-selection');
                    if ($selectionSection.length) {
                        $selectionSection.fadeOut(500, function() {
                            $selectionSection.remove();
                        });
                    }
                }

                // Show success toast
                $.toast({
                    text: data.message,
                    icon: 'success',
                    showHideTransition: 'slide',
                    hideAfter: 4000,
                    stack: 5,
                    position: 'top-right',
                    loaderBg: '#28a745'
                });
                
            } else {
                alert(data.message || 'Wystąpił błąd podczas zapisywania głosu');
            }
        })
        .catch(error => {
            console.error('Error:', error);
            alert('Wystąpił błąd podczas zapisywania głosu');
        })
        .finally(() => {
            $button.prop('disabled', false).html(originalText);
        });
    });
}

/**
 * Complete setup for main page default voice selection
 */
export function setupMainPageDefaultVoice(ensembleSlug) {
    initDefaultVoiceSelect('#default-voice-select');
    handleDefaultVoiceChange('#default-voice-select', '#save-default-voice-button');
    handleDefaultVoiceSave('#save-voice-button', '#default-voice-select', ensembleSlug);
}

/**
 * Complete setup for user profile modal default voice selection
 */
export function setupUserProfileDefaultVoice(ensembleSlug, editedUserId) {
    initDefaultVoiceSelect('#voice-select');
    
    // Custom success callback for user profile
    const userProfileSuccessCallback = (data) => {
        // Update the displayed voice name
        $('#current-default-voice').html(data.voice_name);
        
        // Close modal
        $('#changeVoiceModal').modal('hide');
    };
    
    handleDefaultVoiceSave('#save-voice-btn', '#voice-select', ensembleSlug, editedUserId, {
        onSuccess: userProfileSuccessCallback
    });
}